export const SUPPRESS_OUTSIDE_AFTER_OPEN_MS = 300
